import { render, staticRenderFns } from "./warn_settings.vue?vue&type=template&id=44775be2&scoped=true&"
import script from "./warn_settings.vue?vue&type=script&lang=js&"
export * from "./warn_settings.vue?vue&type=script&lang=js&"
import style0 from "./warn_settings.vue?vue&type=style&index=0&id=44775be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44775be2",
  null
  
)

export default component.exports